'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { Inter } from 'next/font/google';
import { Button } from '@/components/ui/Button';

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-inter',
});

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en" className={inter.variable}>
      <body className={`${inter.className} bg-zinc-950 text-white`}>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center space-y-4 max-w-md px-4">
            <div className="w-12 h-12 rounded-full bg-rose-500/10 flex items-center justify-center mx-auto">
              <svg className="w-6 h-6 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-white text-balance">Something went wrong</h2>
            <p className="text-sm text-zinc-400">
              A critical error occurred. This has been reported automatically.
            </p>
            {error.digest && (
              <p className="text-xs text-zinc-600 font-mono">Error ID: {error.digest}</p>
            )}
            <Button
              onClick={reset}
              className="px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-white text-sm rounded-lg transition-colors"
            >
              Try again
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
